const dataProvider = require('app/www/dataProviders/client/search');
const {SEARCH_GET} = require('app/www/constants/search');
const {userSettingsFallback} = require('app/www/actions/userSettingsFallback');
const {asyncActionError} = require('app/www/actions/asyncActionError');

function search(params) {
    return dispatch => {
        return dataProvider.search(params).then(response => {
            if (!response) {
                return {
                    wannaSee: [],
                    reminders: [],
                    favoriteChannelIds: [],
                };
            }

            const {
                page,
                channels,
                events,
                totalChannels,
                totalEvents,
                wannaSee,
                reminders,
                favoriteChannelIds,
            } = response;

            dispatch({
                type: SEARCH_GET,
                payload: {
                    type: params.type,
                    page,
                    channels,
                    events,
                    totalChannels,
                    totalEvents,
                },
            });

            dispatch(
                userSettingsFallback(response)
            );

            return {
                wannaSee,
                reminders,
                favoriteChannelIds,
            };
        })
        .catch(error => {
            dispatch(
                asyncActionError(error)
            );
        });
    };
}

module.exports = {search};
